import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse} from "@angular/common/http";
import { Observable } from 'rxjs';
import {map} from 'rxjs/operators';
import {HttpOptions} from '../../modele/authModel';
import {SpotifyChannel} from "../../modele/social-media/spotifyModels";
// import * as crypto from 'crypto-js';
import { AESEncryptDecryptService } from '../../services/crypto/crypto.service';



export const FACEBOOK_API_KEY = 'EAAB1ZB46t9nMBAKTnn8uOxZChR4OG87pGoztz5AM5QCfuT7ZAdB8QQmq5ooZCUyZBGJpPnp3Yixr3GHLeSQecKIHGqi4pnW2JhODeN61cLz8AOPnkp2d0lQJyVMwdkZC8p1VYRfwbVp6vvLPVF8y2TEteSzNmkZCrvxEmbNZCzfJYAZDZD';
export const FACEBOOK_API_URL = 'https://graph.facebook.com/';
export const FACEBOOK_API_URL2 = 'https://graph.facebook.com/v8.0/pages/search';

@Injectable({
  providedIn: 'root'
})
export class FacebookService {

  constructor(
    private http: HttpClient,
    // private _AESEncryptDecryptService: AESEncryptDecryptService,
    @Inject(FACEBOOK_API_KEY) private apiKey: string,
    @Inject(FACEBOOK_API_URL) private apiUrl: string,
    @Inject(FACEBOOK_API_URL2) private apiUrl2: string,

  ) {

   }
        search(query: string): Observable <any[] > {

       const params = `v8.0/${query}/posts?fields=created_time,message,shares,likes.summary(true),comments,full_picture&access_token=${this.apiKey}`;
       const queryUrl = `${this.apiUrl}${params}`;
       return new Observable<any[]>((observer) => {
           // let list : VimeoChannel[] = [];
           this.http.get(queryUrl).subscribe(resp => {
               let data = resp['data'];
               observer.next(data);
           });
       });
   }



   searchforProfile(query: string): Observable <any[] > {
  const params = `?q=${query}&access_token=${this.apiKey}`;
  const queryUrl = `${this.apiUrl2}${params}`;
  return new Observable<any[]>((observer) => {
      // let list : VimeoChannel[] = [];
      this.http.get(queryUrl).subscribe(resp => {
          let data = resp['data'];
          observer.next(data);
      });
  });


}
}
